import {
    ImageResourceItem,
    Inject,
    ISimpleControllerConfiguration,
    SimpleBaseController
} from "@denishussar/html5-game-engine";
import Viewport from "pixi-viewport";
import { Point, Rectangle } from 'pixi.js';
import { easeInOutCubic, Easing } from "../../Common/Easing";
import { checkMobile } from "../../Common/Utils";
import { GameLogic } from "../../Logic/GameLogic";
import { BoosterTypeEnum, GameModel, InstrumentTypeEnum } from "../../Models/GameModel";
import { GamePictureController, IGamePictureControllerOption } from './GamePictureController';

export interface IGameViewportController {
    interactiveGlobalRectangle: PIXI.Rectangle,
}

export class GameViewportController extends SimpleBaseController {
    $model: any;

    private frameSize: number = 248;
    private frameSizeInitialized = 248;
    private viewportContainer: PIXI.Container;
    private viewport: Viewport;
    private container: PIXI.Container;
    private frame: PIXI.mesh.NineSlicePlane;
    private picture: GamePictureController;

    private onResizeWidth = 100;
    private onResizeHeight = 100;
    private onResizeScale = 1;

    private dragging = false;
    private mouseDragStart: PIXI.Point;
    private mouseDragLast: PIXI.Point;
    private containerDragStart: PIXI.Point;

    private easings: Array<Easing> = [];

    private oLockUserActions = false;

    /*
    private overlay: Graphics;
    private spinner: Sprite;
     */

    constructor(
        @Inject private options: IGameViewportController,
        @Inject private gameLogic: GameLogic,
        @Inject private model: GameModel,
    ) {
        super('GameViewportController');
    }

    protected getConfiguration(): ISimpleControllerConfiguration {
        const resources = {
            'frame': new ImageResourceItem('frame', 'picture_frame.png'),
            'spinner': new ImageResourceItem('spinner', 'spinner.png'),
        };
        return {
            resources,
            childControllers: {
                picture: {
                    controller: GamePictureController,
                    model: this.$model,
                    options: <IGamePictureControllerOption>{
                        fillColorsAfterInitializtion: true,
                        interactiveGlobalRectangle: this.options.interactiveGlobalRectangle,
                    }
                },
            },
            onPointerUpOutside: () => {
                this.gameLogic.setPaintEnabled(false);
            },
            onPointerDown: () => {
                if (this.gameLogic.getInstrumentType() === InstrumentTypeEnum.paint) {
                    this.gameLogic.setPaintEnabled(true);
                }
            },
            onPointerUp: () => {
                this.gameLogic.setPaintEnabled(false);
            },
            modelEvents: {
                setBoosterType: (value: BoosterTypeEnum) => {
                    switch (value) {
                        case BoosterTypeEnum.yarn:
                            this.updateDragPlugin();
                            break;
                    }
                },
                setColor: (value: number) => {
                    this.scrollToCurrentColor(value);
                },
                setInstrumentType: (value: InstrumentTypeEnum) => {
                    switch (value) {
                        case InstrumentTypeEnum.preview:
                            this.animateToMinimalSize();
                            this.updateDragPlugin();
                            break;

                        case InstrumentTypeEnum.hand:
                            this.animateToMiddleSize();
                            this.updateDragPlugin();
                            break;

                        case InstrumentTypeEnum.paint:
                            this.animateToMiddleSize();
                            this.updateDragPlugin();
                            break;

                        case InstrumentTypeEnum.booster:
                            this.animateToMiddleSize();
                            break;
                    }
                },
                onTextureCreated: e => {
                    this.handleTextureCreated();
                },
                onImageReadyForPaint: e => {
                    //this.spinner.visible = false;
                    //this.overlay.visible = false;
                }
            },
        };
    }

    protected onInitialize(): void {
        this.container = new PIXI.Container();
        this.display.addChild(this.container);

        this.viewportContainer = new PIXI.Container();
        this.display.addChild(this.viewportContainer);

        this.viewport = new Viewport({
            screenWidth: window.innerWidth,
            screenHeight: window.innerHeight,
            worldWidth: 1000,
            worldHeight: 1000,
            interaction: this.renderer.renderer.plugins.interaction,
        });
        this.viewportContainer.addChild(this.viewport);

        this.viewport
            .pinch()
            .drag()
            .wheel();

        /*
        this.overlay = new Graphics();
        this.display.addChild(this.overlay);

        const spinnerTexture = this.getResources().filter((res) => res.name === 'spinner')[0].getTexture();
        this.spinner = new Sprite(spinnerTexture);
        this.spinner.interactive = false;
        this.spinner.anchor.set(0.5);
        this.display.addChild(this.spinner);
         */

        this.viewport.on('wheel', this.handleWheel);
        this.viewport.on('drag-start', this.handleDragStart);
        this.viewport.on('drag-end', this.handleDragEnd);
        this.viewport.on('clicked', this.handleClicked);
        this.viewport.on('touchend', this.handleTouchEnd);
        //@ts-ignore
        this.viewport.on('zoomed', this.handlePinchZoom);
        this.viewport.on('pinch-start', this.handlePinchStart);
        this.viewport.on('pinch-end', this.handlePinchEnd);
        this.viewport.on('moved', this.handlePinchMove);
    }

    private handlePinchStart = () => {
        //@ts-ignore
        const {x, y} = this.viewport.interaction.eventData.data.global;
        this.mouseDragStart = new Point(x, y)
        this.containerDragStart = this.container.position.clone();
        this.dragging = true;
        console.log(this.viewport)

    }
    private handlePinchEnd = () => {

        this.dragging = false
    }
    private handlePinchMove = () => {
        //@ts-ignore
        const {x, y} = this.viewport.interaction.eventData.data.global;

        // TODO: Сделать по красоте, чтобы перемещение не дергалось изза смены ведущего пальца
        this.handleMoved({
            data: {
                originalEvent: {
                    clientX: x,
                    clientY: y
                }
            }
        })
    }

    protected onDestroy(): void {
        this.viewport.off('wheel', this.handleWheel);
        this.viewport.off('drag-start', this.handleDragStart);
        this.viewport.off('drag-end', this.handleDragEnd);
        this.viewport.off('clicked', this.handleClicked);
        this.viewport.off('pointermove', this.handleMoved);
        //@ts-ignore
        this.viewport.off('zoomed', this.handlePinchZoom);
        this.viewport.off('pinch-start', this.handlePinchStart);
        this.viewport.off('pinch-end', this.handlePinchEnd);
        this.viewport.off('moved', this.handlePinchMove);
    }

    protected onUpdate(frameRate: number) {
        this.easings.forEach((easing) => {
            easing.update(frameRate);
        });

        if (this.easings.length > 0) {
            return;
        }

        if (this.dragging && this.mouseDragLast) {
            this.handleMovedUpdate(this.mouseDragLast);
            this.mouseDragLast = undefined;
        }

        /*
        if (this.spinner && this.spinner.visible) {
            this.spinner.rotation += 10 * frameRate;
        }
         */
    }

    protected onResize(width: number, height: number, scale: number) {
        this.onResizeWidth = width;
        this.onResizeHeight = height;
        this.onResizeScale = scale;

        const vWidth = width / scale * 2;
        const vHeight = height / scale * 2;
        this.viewport.resize(vWidth, vHeight);
        this.viewportContainer.position.set(-vWidth / 2, -vHeight / 2);

        if (!this.frame) {
            if (this.$model.saveTexture) {
                this.handleTextureCreated();
            }
            return;
        }
    }

    public lockUserActions(value: boolean): void {
        this.oLockUserActions = value;

        this.viewport.off('wheel', this.handleWheel);
        this.viewport.off('drag-start', this.handleDragStart);
        this.viewport.off('drag-end', this.handleDragEnd);
        //@ts-ignore
        this.viewport.off('zoomed', this.handlePinchZoom);
        this.viewport.off('pinch-start', this.handlePinchStart);
        this.viewport.off('pinch-end', this.handlePinchEnd);
        this.viewport.off('moved', this.handlePinchMove);

        if (!value) {
            this.viewport.on('wheel', this.handleWheel);
            this.viewport.on('drag-start', this.handleDragStart);
            this.viewport.on('drag-end', this.handleDragEnd);
            //@ts-ignore
            this.viewport.on('zoomed', this.handlePinchZoom);
            this.viewport.on('pinch-start', this.handlePinchStart);
            this.viewport.on('pinch-end', this.handlePinchEnd);
            this.viewport.on('moved', this.handlePinchMove);
        }

        this.updateDragPlugin();
    }

    private _lastScaleViewport;

    private handlePinchZoom = (e: {viewport: Viewport, type: string}) => {
        if (e.type !== 'pinch') return;
        if (!this._lastScaleViewport) {
            this._lastScaleViewport = e.viewport.scale.x;
        }

        this.gameLogic.setPaintEnabled(false);
        switch (this.gameLogic.getInstrumentType()) {
            default:

                const additionalScale = e.viewport.scale.x - this._lastScaleViewport;
                const s = this.container.scale.x + additionalScale * 3;

                let scale = s;
                scale = Math.min(Math.max(this.getMinScale(), s), this.getMaxScale());

                this.logZoom(this.container.scale.x, scale);
                this.container.scale.x = scale;
                this.container.scale.y = scale;
        }

        this._lastScaleViewport = e.viewport.scale.x;
    }

    private handleTextureCreated(): void {
        const margin = 64;
        const pictureSize = {
            width: this.gameLogic.getPictureSize().width * this.gameLogic.getPixelSize(),
            height: this.gameLogic.getPictureSize().height * this.gameLogic.getPixelSize(),
        };


        if (!this.frame) {
            const frameTexture = this.getResources().filter((res) => res.name === 'frame')[0].getTexture();
            this.frame = new PIXI.mesh.NineSlicePlane(frameTexture, this.frameSize, this.frameSize, this.frameSize, this.frameSize);
            this.frame.interactive = false;
            this.container.addChild(this.frame);
        }
        this.frame.width = pictureSize.width + 2 * margin;
        this.frame.height = pictureSize.height + 2 * margin;
        this.frame.position.set(-this.frame.width / 2, -this.frame.height / 2);
        this.frameSizeInitialized = this.frame.width;

        if (!this.picture) {
            this.picture = this.$childControllers.get<GamePictureController>('picture');
            this.container.addChild(this.picture.display);
        }
        this.picture.display.position.set(this.frame.position.x + margin, this.frame.position.y + margin);

        this.center();
        this.animateToMinimalSize();
    }

    private handleClicked = (e) => {
        this.picture.click({
            globalPosition: new Point(e.viewport.interaction.eventData.data.global.x, e.viewport.interaction.eventData.data.global.y),
            mouseEvent: {button: 0},
            localPosition: new Point,
            screenPosition: new Point,
            preventDefault: function (): void {
                throw new Error("Function not implemented.");
            },
            stopPropagation: function (): void {
                throw new Error("Function not implemented.");
            }
        })
    }
    private handleTouchEnd = (e) => {
        this.picture.touchEnd(e)
    }

    private handleDragStart = (e) => {
        this.model.dragCount++;

        this.gameLogic.setPaintEnabled(false);

        if (this.easings.length > 0) {
            return;
        }

        if (this.gameLogic.getInstrumentType() === InstrumentTypeEnum.preview) {
            return;
        }

        this.mouseDragStart = new Point(
            e.viewport.interaction.eventData.data.originalEvent.clientX,
            e.viewport.interaction.eventData.data.originalEvent.clientY
        );

        this.mouseDragLast = this.mouseDragStart.clone();

        const tl = this.frame.toGlobal(new Point(0, 0))
        const br = this.frame.toGlobal(new Point(this.frame.getLocalBounds().width, this.frame.getLocalBounds().height));

        if (
            tl.x / window.devicePixelRatio > this.mouseDragStart.x
            || tl.y / window.devicePixelRatio > this.mouseDragStart.y
            || br.x / window.devicePixelRatio < this.mouseDragStart.x
            || br.y / window.devicePixelRatio < this.mouseDragStart.y
        ) {
            return;
        }

        this.containerDragStart = this.container.position.clone();

        this.dragging = true;

        this.viewport.off('pointermove', this.handleMoved);
        this.viewport.on('pointermove', this.handleMoved);
    }

    private handleDragEnd = (e) => {
        this.viewport.off('pointermove', this.handleMoved);
        this.dragging = false;
    }

    private handleMoved = (e) => {
        this.mouseDragLast = new Point(
            e.data.originalEvent.clientX,
            e.data.originalEvent.clientY
        );
    }

    private handleMovedUpdate = (point: Point) => {
        let x = this.containerDragStart.x + (point.x - this.mouseDragStart.x) / this.onResizeScale * this.container.scale.y;
        let y = this.containerDragStart.y + (point.y - this.mouseDragStart.y) / this.onResizeScale * this.container.scale.y;
        // console.warn({x, y})

        // ------------- TODO drag bounds

        // const deltaX = this._mouseDragStart.x - point.x;
        // const deltaY = this._mouseDragStart.y - point.y;
        // const tl = this._frame.toGlobal(new Point(0, 0));
        // const br = this._frame.toGlobal(new Point(this._frame.width, this._frame.height));
        // tl.x += deltaX;
        // tl.y += deltaY;
        // br.x += deltaX;
        // br.y += deltaY;

        // const left = this.renderer.renderer.view.width * .2;
        // const right = this.renderer.renderer.view.width * .8;
        // const top = this.renderer.renderer.view.height * .2;
        // const bottom = this.renderer.renderer.view.height * .8;

        // if (tl.x > left) {
        //     x = x - (tl.x - left) * this._onResizeScale;
        // }
        // if (br.x < right) {
        //     x = x + (right - br.x) * this._onResizeScale;
        // }

        // if (tl.y > top) {
        //     y = y - (tl.y - top) * this._onResizeScale;
        // }
        // if (br.y < bottom) {
        //     y = y + (bottom - br.y) * this._onResizeScale;
        // }

        // --------------

        this.container.position.x = x;
        this.container.position.y = y;
    }

    public zoom(value: boolean) {
        if (this.easings.length > 0) {
            // animating - ignor event
            return;
        }

        // if (!value) {
        //     this.model.zoomInCount++;
        // } else {
        //     this.model.zoomOutCount++;
        // }

        this.handleWheel(
            {
                event: {
                    deltaY: value ? 90 : -90,
                    deltaMode: 0,
                }
            },
            true
        );
    }

    private tID?: number;
    private startScale: number;
    private logZoom(oldScale: number, newScale: number): void {
        if (this.tID) {
            clearTimeout(this.tID);
        }

        if (!this.startScale) {
            this.startScale = oldScale;
        }

        this.tID = setTimeout(() => {
            this.tID = undefined;
            if (this.startScale < newScale) {
                this.model.zoomInCount++;
                console.log("[EVENT] ZoomIN count add")
            } else {
                this.model.zoomOutCount++;
                console.log("[EVENT] ZoomOUT count add")
            }

            this.startScale = undefined;
        }, 300) as any as number;
    }

    private handleWheel = (e, centerAndAnimate = false) => {
        if (this.easings.length > 0) {
            // animating - ignor event
            return;
        }

        const reverse = false;
        const percent = .1;

        const sign = reverse ? -1 : 1;
        const step = sign * -e.event.deltaY * (e.event.deltaMode ? 120 : 1) / 500;
        const change = Math.pow(2, (1 + percent) * step);

        /*
        if (!centerAndAnimate) {
            if (sign > 0) {
                this.model.zoomInCount++;
            } else {
                this.model.zoomOutCount++;
            }

            console.log('zoomInCount', this.model.zoomInCount);
            console.log('zoomOutCount', this.model.zoomOutCount);
        }
         */

        switch (this.gameLogic.getInstrumentType()) {
            case InstrumentTypeEnum.preview:
                if (step > 0) {
                    if (this.gameLogic.getColorIndex() !== -1) {
                        this.gameLogic.setInstrumentType(InstrumentTypeEnum.paint);
                    } else {
                        this.gameLogic.setInstrumentType(InstrumentTypeEnum.hand);
                    }
                }
                break;
            default:
                const s = this.container.scale.x * change;

                let scale = s;
                scale = s < this.getMinScale() ? this.getMinScale() : s;
                scale = s > this.getMaxScale() ? this.getMaxScale() : s;

                this.logZoom(this.container.scale.x, scale);

                if (scale < this.getMidScale()) {
                    this.gameLogic.setInstrumentType(InstrumentTypeEnum.preview);
                } else {
                    const object = this.container;

                    let mouse = this.viewport.getPointerPosition(e.event);
                    let objectLocal = object.toLocal(mouse);

                    if (!centerAndAnimate) {
                        this.container.scale.x = scale;
                        this.container.scale.y = scale;
                        // this.viewport.scale.x = scale;
                        // this.viewport.scale.y = scale;

                        let objectLocal1 = object.toLocal(mouse);

                        this.container.position.x += (objectLocal1.x - objectLocal.x) / this.onResizeScale;
                        this.container.position.y += (objectLocal1.y - objectLocal.y) / this.onResizeScale;
                    } else {
                        this.animatePictureZooming(scale, new PIXI.Point(0, 0));
                    }
                }
        }
    }

    private animateToMinimalSize(): void {
        this.animatePictureZooming(this.getMinScale(), new PIXI.Point(0, 0));
    }

    private animateToMiddleSize(center: Point | undefined = undefined): void {
        const midScale = Math.max(this.container.scale.y, this.getMidScale());

        this.animatePictureZooming(midScale, new PIXI.Point(0, 0))
            .then(() => {
                this.scrollToCurrentColor();
            })
    }

    private scrollToCurrentColor(currentColor: number = -1): void {
        const colorIndex = currentColor == -1 ? this.gameLogic.getColorIndex() : currentColor;
        if (
            colorIndex < 1
            || this.gameLogic.getInstrumentType() <= InstrumentTypeEnum.hand
        ) {
            return;
        }
        const color = this.gameLogic.getColor();
        const pictureSize = this.gameLogic.getPictureSize();
        const pixelsCount = pictureSize.width * pictureSize.height;
        const notColoredPixels: Point[] = [];

        for (let i = 0; i < pixelsCount; i++) {
            const y = i % pictureSize.width;
            const x = (i - y) / pictureSize.width;
            const pixelColor = this.gameLogic.getPixelColor(x, y);

            if (pixelColor !== color) {
                continue;
            }
            if (this.gameLogic.isColored(x, y)) {
                continue;
            }

            notColoredPixels.push(new Point(x, y));
        }

        const tl = this.picture.display.toLocal(
            new Point(this.options.interactiveGlobalRectangle.x, this.options.interactiveGlobalRectangle.y),
            this.renderer.stage
        );
        const br = this.picture.display.toLocal(
            new Point(
                this.options.interactiveGlobalRectangle.x + this.options.interactiveGlobalRectangle.width,
                this.options.interactiveGlobalRectangle.y + this.options.interactiveGlobalRectangle.height
            ),
            this.renderer.stage
        );
        const margin = 100;
        let localDeltaX = Number.MAX_SAFE_INTEGER;
        let localDeltaY = Number.MAX_SAFE_INTEGER;
        let localPointX: number;
        let localPointY: number;
        const localRectangle = new Rectangle(tl.x + margin, tl.y + margin, br.x - tl.x - 2 * margin, br.y - tl.y - 2 * margin);
        for (let i = 0; i < notColoredPixels.length; i++) {
            const x = this.picture.display.width / pictureSize.width * notColoredPixels[i].x;
            const y = this.picture.display.height / pictureSize.height * notColoredPixels[i].y;
            if (localRectangle.contains(x, y)) {
                // имеется видимый пиксель - скролить не надо
                return;
            } else {
                const deltaX = x < tl.x ? tl.x - x + margin : x - br.x - margin;
                const deltaY = y < tl.y ? tl.y - y + margin : y - br.y - margin;
                if (Math.abs(localDeltaX) > Math.abs(deltaX)) {
                    localDeltaX = deltaX;
                    localPointX = x;
                    localPointY = y;
                }
                if (Math.abs(localDeltaY) > Math.abs(deltaY)) {
                    localDeltaY = deltaY;
                    localPointX = x;
                    localPointY = y;
                }
            }
        }

        if (localDeltaX === Number.MAX_SAFE_INTEGER || localDeltaY === Number.MAX_SAFE_INTEGER) {
            // ерунда какая-то
            return;
        }

        let p = this.picture.display.toGlobal(new Point(localPointX, localPointY));
        p = this.container.parent.toLocal(p, this.renderer.stage);

        this.animatePictureZooming(
            this.container.scale.y,
            new Point(
                this.container.x - p.x,
                this.container.y - p.y
            )
        );
    }

    private updateDragPlugin(): void {
        if (!this.viewport) {
            return;
        }

        this.viewport.removePlugin('drag');
        this.viewport.removePlugin('pinch');

        if (this.oLockUserActions) {
            return;
        }

        switch (this.gameLogic.getInstrumentType()) {
            case InstrumentTypeEnum.preview:
                this.viewport.pinch({
                    noDrag: true,
                });
                break;
            case InstrumentTypeEnum.hand:
                if (checkMobile()) {
                    this.viewport.drag({
                        mouseButtons: 'all'
                    });
                    this.viewport.pinch();
                } else {
                    this.viewport.drag({
                        mouseButtons: 'all'
                    });
                    this.viewport.pinch();
                }
                break;
            case InstrumentTypeEnum.paint:
                if (checkMobile()) {
                    this.viewport.pinch({
                        noDrag: true,
                    });
                } else {
                    this.viewport.drag({
                        mouseButtons: 'right'
                    });
                    this.viewport.pinch({
                        noDrag: true,
                    });
                }
                break;
        }
    }

    private center(): void {
        if (!this.frame) {
            return;
        }

        this.container.position.set(0, 0);
    }

    private getMinScale(): number {
        const minSize = Math.min(this.onResizeWidth, this.onResizeHeight);
        const scale = minSize / this.frameSizeInitialized;

        return scale / this.onResizeScale;
    }

    private getMidScale(): number {
        return GameModel.minimalVisibleEditedPixelSize / GameModel.pixelSize / this.onResizeScale;
    }

    private getMaxScale(): number {
        return GameModel.maximalVisibleEditedPixelSize / GameModel.pixelSize / this.onResizeScale;
    }

    private animatePictureZooming(endScale: number, endPosition: Point): Promise<any> {
        let resolve: Function;
        const promise = new Promise((res) => {
            resolve = res;
        });

        this.easings.splice(0);

        const timeout = 600;
        const startScale = this.container.scale.y;

        const startPosition = this.container.position.clone();

        const easing = new Easing(
            [startScale, startPosition.x, startPosition.y],
            [endScale, endPosition.x, endPosition.y],
            timeout,
            easeInOutCubic
        );

        easing.onComplete = () => {
            for (let i = 0; i < this.easings.length; i++) {
                if (this.easings[i] === easing) {
                    this.easings.splice(i, 1);
                    if (resolve) {
                        resolve();
                        resolve = undefined;
                    }
                    break;
                }
            }
        };
        easing.onStep = (values: Array<number>) => {
            if (this.container) {
                this.container.scale.set(values[0]);
                // this.viewport.scale.set(values[0]);
                this.container.position.set(values[1], values[2]);
            }
        };
        this.easings.push(easing);

        return promise;
    }
}
